import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import searchIndex from './search-index.json';


const SearchResults = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get('query')?.toLowerCase();

  const [data, setData] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);

  // Flatten grouped data into a single array
  useEffect(() => {
    if (searchIndex && typeof searchIndex === 'object' && !Array.isArray(searchIndex)) {
      const flattened = Object.values(searchIndex).flat();
      setData(flattened);
    } else if (Array.isArray(searchIndex)) {
      setData(searchIndex);
    } else {
      console.error('Invalid format for search data:', searchIndex);
    }
  }, []);

  // Filter based on search query
  useEffect(() => {
    if (!searchQuery || !Array.isArray(data)) return;

    const seenFiles = new Set();

    const results = data.reduce((acc, item) => {
      const contentLower = item.content?.toLowerCase() || '';
      const titleLower = item.title?.toLowerCase() || '';

      if ((contentLower.includes(searchQuery) || titleLower.includes(searchQuery)) && !seenFiles.has(item.file)) {
        seenFiles.add(item.file);

        const matchIndex = contentLower.indexOf(searchQuery);
        const start = Math.max(0, matchIndex - 60);
        const end = Math.min(contentLower.length, matchIndex + 150);
        const snippet = contentLower.includes(searchQuery)
          ? item.content.substring(start, end) + '...'
          : item.content.substring(0, 200) + '...';

        acc.push({
          //title: item.title,
         // file: item.file,
          link: item.link,
          snippet
        });
      }

      return acc;
    }, []);

    setFilteredResults(results);
  }, [searchQuery, data]);

  return (
     <div className="container max-1330">
    <div >
      {/* <div style={{ padding: '20px' }}> */}
      <h2>Search Results fo1: "{searchQuery}"</h2>
      {filteredResults.length === 0 ? (
         <p>No results found. If you can’t find what you’re looking for, please <a href="/contact-us?section=query-form">submit a query form here</a>.</p>
      ) : (
        <ul>
          {filteredResults.map((item, index) => (
            <li key={index} style={{ marginBottom: '20px' }}>
              <strong>{item.title}</strong> <br />
              <code>{item.file}</code>
              <p>{item.snippet}</p>
              <a href={item.link}>Go to Page</a>
            </li>
          ))}
        </ul>
      )}
    </div>
     </div>
  );
};

export default SearchResults;





